// Small JSON GET helper shared by the v2 fetch-API modules
// (contact assignment, deal assignment). Throws on non-2xx
// so callers can `.catch` a single failure path.
export async function getJson<T>(
  url: string,
  signal?: AbortSignal,
): Promise<T> {
  const res = await fetch(url, {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    signal,
  })
  if (!res.ok) throw new Error(`Request failed: ${res.status}`)
  return (await res.json()) as T
}
